import styled, { keyframes } from 'styled-components';
import { Card, Input } from 'antd';

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0;
  background-color: var(--bg);
  color: var(--ink);
  align-items: center;
  justify-content: center;
`;

export const FormContainer = styled.div`
  background-color: var(--surface);
  border: 1px solid var(--line);
  padding: 2rem;
  border-radius: 8px;
  width: min(400px, calc(100vw - 32px));
  box-shadow: var(--shadow);
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;

  img {
    width: 144px;
    height: auto;
  }
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: 1.5rem;
  color: var(--ink);
  font-size: 1.25rem;
  font-weight: 600;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.2rem;
`;

export const ErrorMessage = styled.div`
  color: #ff4444;
  text-align: center;
  margin-bottom: 1rem;
`;

export const SuccessMessage = styled.div`
  color: var(--good);
  text-align: center;
  margin-bottom: 1rem;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: var(--ink-2);
  font-weight: 500;
  font-size: 13px;
`;

export const FormItem = styled.div`
  margin-bottom: 1.2rem;
`;

export const StyledInput = styled(Input)`
  width: 100%;
  padding: 0.6rem;
  border-radius: 4px;
`;

export const StyledError = styled.div`
  color: #ff4d4f;
  margin-top: 0.25rem;
  font-size: 0.85rem;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  border: 3px solid #222;
  border-top: 3px solid #00d8a5;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`;

export const FormWrapper = styled(Card)`
  max-width: 350px;
  margin: 200px auto auto;
  border-radius: 10px;
  background-color: #1e1e1e;
`;

export const Wrapper = styled.div`
  background-color: #000000;
  height: 100%;
  position: absolute;
  width: 100%;
  background-image: linear-gradient(
    180deg,
    #000000,
    #1e90ff 500%,
    /* replace #1e90ff with your desired primary color */ #1e90ff
  );

  .ant-btn {
    width: 100%;
  }
`;
